import { render, staticRenderFns } from "./PipelinePergola.vue?vue&type=template&id=8465a316&scoped=true&"
import script from "./PipelinePergola.vue?vue&type=script&lang=js&"
export * from "./PipelinePergola.vue?vue&type=script&lang=js&"
import style0 from "./PipelinePergola.vue?vue&type=style&index=0&id=8465a316&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8465a316",
  null
  
)

export default component.exports